<template>
    <div :class="{'bg-gray-500' : !ready}" class="relative aspect-ratio-16/9 bg-black">
        <component
            :is="component"
            v-if="ready"
            :key="`${source.provider} ${source.id}`"
            ref="player"
            :options="options"
            :video-id="source.id"
            class="absolute inset-0 w-full h-full video-component"
            @loaded="onLoad"
            @ready="onLoad"/>
    </div>
</template>

<script>

import urlParser from "js-video-url-parser";

export default {

    name: 'VideoComponent',

    props: {
        src: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            options: {
                title: false,
                portrait: false,
                byline: false,
            }
        };
    },

    methods: {
        async onLoad() {
            const duration = await this.$refs.player.player.getDuration();
            this.$emit('durationChanged', duration);
        },
        async seek(position) {
            if (!_.has(this.source, 'provider')) {
                return;
            }

            switch (this.source.provider) {
                case 'youtube':
                    this.$refs.player.player.seekTo(position, true);
                    break;
                case 'vimeo':
                    await this.$refs.player.player.setCurrentTime(position);
                    await this.$refs.player.player.play();

                    break;
            }
        }
    },

    computed: {
        ready() {
            return !!this.component;
        },
        source() {
            return urlParser.parse(this.src) || {};
        },
        component() {

            if (!_.has(this.source, 'provider')) {
                return;
            }

            switch (this.source.provider) {
                case 'youtube':
                    return 'YoutubeVideo';
                case 'vimeo':
                    return 'vimeo-player';
            }
        }
    },
}
</script>
